// @flow
/* eslint no-irregular-whitespace: 0 */

// NOTE:
// app/models/another_paper_template.rbの定義を参照
// 従って、内容を修正する場合は上記ファイルも同時に修正が必要
export const anotherPaperTemplates = [
  {
    id: 1,
    name: '別紙A',
    content: `１．新株予約権の数の上限
    {{・・・個}}を上限とする（うち、取締役への付与は{{●個}}を上限とする）。
        なお、新株予約権１個当たりの目的となる株式数は、{{・・・株}}とする。
    　　（ただし、３．（１）に定める株式の数の調整を行った場合は、同様の調整を行う。）
    ２．新株予約権と引換えに払い込む金銭
    　　新株予約権と引換えに金銭を払い込むことを要しない。
    ３．新株予約権の内容
    （１）割り当てる新株予約権の目的となる株式の種類及び数
      　 当社普通株式{{・・・株}}を新株予約権の目的となる株式数の上限とする。
    なお、当社が株式分割（株式無償割当を含む。）又は株式併合を行う場合、次の算式により目的となる株式の数を調整するものとする。ただし、かかる調整は、新株予約権のうち、当該時点で権利行使されていない新株予約権の目的となる株式の数について行われ、調整の結果生じる１株未満の端数については、これを切り捨てる。
              調整後株式数＝調整前株式数×分割・併合の比率
    　　　また、当社が吸収合併、新設合併、吸収分割、新設分割、株式交換もしくは株式移転を行う場合又はその他やむを得ない事由が生じた場合には、新株予約権の目的となる株式の数は、合理的な範囲で調整されるものとする。
    （２）新株予約権の行使に際して出資される財産の価額
      　 新株予約権の行使に際して出資される財産の価額は、次により決定される１株当たりの払込金額（以下「行使価額」という。）に１．に定める新株予約権１個の株式数を乗じた金額とする。
    行使価額は、{{・・・円}}とする。
    なお、当社が株式分割（株式無償割当を含む。）又は株式併合を行う場合、次の算式により行使価額を調整し、１円未満の端数は切り上げる。
    　　　　　　　　　　　　　　　　　　　　　1
    調整後行使価額 ＝ 調整前行使価額 × ──────────────
    　　　　　　　　　　　　　　　　　　分割・併合の比率

    また、当社が時価を下回る払込金額で募集株式の発行又は自己株式の処分を行う場合(新株予約権の行使に基づく株式の発行・処分を除く)は、次の算式により行使価額を調整し、調整により生じる１円未満の端数は切り上げる。

    　　　　　　　　　　　　　　  　　新規発行株式数×1株あたり払込金額
    　　　　　　　　　　 既発行株式数 ＋ ──────────────────
    調整後 　　   調整前　　　　　　　　     　　　　1株当たりの時価
    行使価額 ＝ 行使価額 × ──────────────────────────
    　　　　　　　　　　　　既発行株式数 ＋ 新規発行株式数

    上記算式において「既発行株式数」とは、当社の発行済株式総数から当社が保有する自己株式数を控除した数とし、自己株式の処分を行う場合には「新規発行」を「自己株式の処分」、「１株当たり払込金額」を「１株当たり処分金額」と読み替えるものとする。
    　　　さらに、上記のほか、当社が吸収合併、新設合併、吸収分割、新設分割、株式交換もしくは株式移転を行う場合又はその他やむを得ない事由が生じた場合には、行使価額は合理的な範囲で調整されるものとする。
    （３）新株予約権を行使することができる期間
    　　　新株予約権の付与決議の日後２年を経過した日から、当該決議の日後１０年を経過する日までとする。
    　　　ただし、権利行使の最終日が当社の休日にあたる場合にはその前営業日を権利行使の最終日とする。
    （４）増加する資本金及び資本準備金に関する事項
    新株予約権の行使により株式を発行する場合において増加する資本金の額は、会社計算規則第１７条第1項に従い算出される資本金等増加限度額の２分の１の金額とし、計算の結果１円未満の端数が生じたときは、その端数を切り上げるものとする。
    　　 本新株予約権の行使により株式を発行する場合において増加する資本準備金の額は、上記の資本金等増加限度額から上記に定める増加する資本金の額を減じた額とする。
    （５）譲渡による新株予約権の取得の制限
            譲渡による新株予約権の取得については、当社取締役会の決議による承認を要するものとする。
    （６）新株予約権の行使の条件
    {{①　▲▲}}
    （７）新株予約権の取得事由
    ①　新株予約権者が権利行使をする前に、当社が消滅会社となる合併契約承認の議案又は当社が完全子会社となる株式交換契約承認もしくは株式移転計画承認の議案につき株主総会で承認された場合（株主総会決議が不要の場合は、当社取締役会決議がなされた場合）は、当社は、取締役会が別途定める日に、無償で本新株予約権を取得することができる。
    ②　新株予約権者が権利行使をする前に、新株予約権の行使の条件の規定に該当しなくなった場合、及び新株予約権者が保有する新株予約権を放棄した場合には、当社は、取締役会の決議により別途定める日において本新株予約権の全部又は一部を無償で取得することができ、一部を取得する場合は、取締役会の決議により取得する本新株予約権を決定するものとする。
    （８） 当社が組織再編行為を実施する際の新株予約権の取扱い
    　　　　当社が合併（当社が合併により消滅する場合に限る。）、吸収分割、新設分割、株式交換又は株式移転（以上を総称して以下「組織再編行為」という。）をする場合において、組織再編行為の効力発生日において残存する新株予約権（以下「残存新株予約権」という。）の新株予約権者に対し、それぞれの場合につき、会社法第２３６条第１項第８号のイからホまでに掲げる株式会社（以下「再編対象会社」という。）の新株予約権を以下の条件に基づきそれぞれ交付することとする。この場合においては、残存新株予約権は消滅し、再編対象会社は新株予約権を新たに発行するものとする。ただし、以下の条件に沿って再編対象会社の新株予約権を交付する旨を、吸収合併契約、新設合併契約、吸収分割契約、新設分割計画、株式交換契約又は株式移転計画において定めた場合に限るものとする。
    ①　交付する再編対象会社の新株予約権の数
    組織再編行為の効力発生の時点において残存する募集新株予約権の新株予約権者が保有する新株予約権の数と同一の数をそれぞれ交付するものとする。
    ②　新株予約権の目的である再編対象会社の株式の種類
    　　　 再編対象会社の普通株式とする。
    ③　新株予約権の目的である再編対象会社の株式の数
    　　　 組織再編行為の条件等を勘案のうえ、前記（１）に準じて決定する。
    ④　新株予約権の行使に際して出資される財産の価額
    　　　 交付される各新株予約権の行使に際して出資される財産の価額は、組織再編行為の条件等を勘案のうえ、前記（２）で定められた行使価額を調整して得られる再編後払込金額に上記③に従って決定される当該新株予約権の目的である再編対象会社の株式の数を乗じて得られる金額とする。
    ⑤　新株予約権を行使することができる期間
    　　　 前記（３）に定める新株予約権を行使できる期間の開始日と組織再編行為の効力発生日のうちいずれか遅い日から、前記（３）に定める新株予約権を行使することができる期間の満了日までとする。
    ⑥　新株予約権の行使の条件
    　　　 前記（６）に準じて決定する。
    ⑦　増加する資本金及び資本準備金に関する事項
    前記（４）に準じて決定する。
    ⑧　譲渡による新株予約権の取得の制限
    　　　 譲渡による新株予約権の取得については、再編対象会社の承認を要するものとする。
    ⑨　新株予約権の取得事由
    　　　 前記（７）に準じて決定する。
    （９） 新株予約権の行使により発生する端数の切捨て
    　　　 新株予約権者に交付する株式の数に１株に満たない端数がある場合には、これを切り捨てるものとする。`,
  },
  {
    id: 2,
    name: '別紙B',
    content: `{{第・・・回新株予約権}}割当契約書

    {{・・・株式会社}}（以下、「甲」という。）と○○○○（以下、「乙」という。）は、会社法第236条及び第238条並びに第239条の規定に基づき、甲が発行する新株予約権の割当てに関し、以下のとおり合意し、契約を締結する。

    （新株予約権の割当て）
    第１条　　甲は、{{＊▲年＊▲月＊▲日}}開催の{{第▲回定時/臨時}}株主総会、普通株主による{{定時/臨時}}種類株主総会、{{Ａ種}}株主による{{定時/臨時}}種類株主総会並びに募集事項及び割当者を決定した{{●年●月●日}}開催の取締役会決議に基づき、乙に対し、第2条【新株予約権の要領】に定める新株予約権（以下、「本新株予約権」という。）{{○○個}}（新株予約権の目的となる株式の種類及び数　{{普通株式○○株}}）を割当て、乙はこれを引き受ける。

    （新株予約権の内容）
    第２条　　本新株予約権の内容は、本契約において別に定める場合を除き、以下の要領のとおりとする。
    【新株予約権の要領】
    １．新株予約権の名称　
    {{第・・・回新株予約権}}
    ２．発行する新株予約権の数
    　{{・・・個}}
    なお、新株予約権１個当たりの目的となる株式数は、{{・・・株}}とする。
    （ただし、５．発行する新株予約権の内容（１）に定める株式の数の調整を行った場合は、同様の調整を行う。）
    ３．割当日
    　　{{＊▲年＊▲月＊▲日}}
    ４．新株予約権と引換えに払い込む金銭
    新株予約権と引換えに金銭を払い込むことを要しない。
    ５．発行する新株予約権の内容
    （１）割り当てる新株予約権の目的となる株式の種類及び数
    当社普通株式・・・株を新株予約権の目的となる株式数とする。
    なお、当社が株式分割（株式無償割当を含む。）又は株式併合を行う場合、次の算式により目的となる株式の数を調整するものとする。ただし、かかる調整は、新株予約権のうち、当該時点で権利行使されていない新株予約権の目的となる株式の数について行われ、調整の結果生じる１株未満の端数については、これを切り捨てる。
              調整後株式数＝調整前株式数×分割・併合の比率
    　　　また、当社が吸収合併、新設合併、吸収分割、新設分割、株式交換若しくは株式移転を行なう場合又はその他やむを得ない事由が生じた場合には、新株予約権の目的となる株式の数は、合理的な範囲で調整されるものとする。
    （２）新株予約権の行使に際して出資される財産の価額
          新株予約権の行使に際して出資される財産の価額は、次により決定される１株当たりの払込金額（以下「行使価額」という。）に２．に定める新株予約権1個の株式数を乗じた金額とする。
    行使価額は、{{・・・円}}とする。
    なお、当社が株式分割（株式無償割当を含む。）又は株式併合を行う場合、次の算式により行使価額を調整し、１円未満の端数は切り上げる。
    　　　　　　　　　　　　　　　　　　　　　1
    調整後行使価額 ＝ 調整前行使価額 × ──────────────
    　　　　　　　　　　　　　　　　　　分割・併合の比率

    また、当社が時価を下回る払込金額で募集株式の発行又は自己株式の処分を行う場合(新株予約権の行使に基づく株式の発行・処分を除く)は、次の算式により行使価額を調整し、調整により生じる１円未満の端数は切り上げる。

    　　　　　　　　　　　　　　  　　新規発行株式数×1株あたり払込金額
    　　　　　　　　　　 既発行株式数 ＋ ──────────────────
    調整後 　　   調整前　　　　　　　　     　　　　1株当たりの時価
    行使価額 ＝ 行使価額 × ──────────────────────────
    　　　　　　　　　　　　既発行株式数 ＋ 新規発行株式数

    上記算式において「既発行株式数」とは、当社の発行済株式総数から当社が保有する自己株式数を控除した数とし、自己株式の処分を行う場合には「新規発行」を「自己株式の処分」、「1株当たり払込金額」を「1株当たり処分金額」と読み替えるものとする。
    　　  さらに、上記のほか、当社が吸収合併、新設合併、吸収分割、新設分割、株式交換若しくは株式移転を行なう場合又はその他やむを得ない事由が生じた場合には、行使価額は、合理的な範囲で調整されるものとする。
    （３）新株予約権を行使することができる期間
    {{＊▲年＊▲月＊▲日}}から{{＊▲年＊▲月＊▲日}}までとする。
    　　　　ただし、権利行使の最終日が当社の休日にあたる場合には、その前営業日を権利行使の最終日とする。
    （４）増加する資本金及び資本準備金に関する事項
    新株予約権の行使により株式を発行する場合において増加する資本金の額は、会社計算規則第17条第1項に従い算出される資本金等増加限度額の2分の1の金額とし、計算の結果1円未満の端数が生じたときは、その端数を切り上げるものとする。本新株予約権の行使により株式を発行する場合において増加する資本準備金の額は、上記の資本金等増加限度額から上記に定める増加する資本金の額を減じた額とする。
    （５）譲渡による新株予約権の取得の制限
    譲渡による新株予約権の取得については、当社取締役会の決議による承認を要するものとする。
    （６）新株予約権の行使の条件
    {{①　▲▲}}
    （７）新株予約権の取得事由
    ①　新株予約権者が権利行使をする前に、当社が消滅会社となる合併契約承認の議案又は当社が完全子会社となる株式交換契約承認若しくは株式移転計画承認の議案につき株主総会で承認された場合（株主総会決議が不要の場合は、当社取締役会決議がなされた場合）は、当社は、取締役会が別途定める日に、無償で新株予約権を取得することができる。
    ②　新株予約権者が権利行使をする前に、新株予約権の行使の条件の規定に該当しなくなった場合、及び新株予約権者が保有する新株予約権を放棄した場合には、当社は、取締役会の決議により別途定める日において新株予約権の全部又は一部を無償で取得することができ、一部を取得する場合は、取締役会の決議により取得する新株予約権を決定するものとする。
    （８）当社が組織再編行為を実施する際の新株予約権の取扱い
    当社が合併（当社が合併により消滅する場合に限る。）、吸収分割、新設分割、株式交換又は株式移転（以上を総称して以下「組織再編行為」という。）をする場合において、組織再編行為の効力発生日において残存する新株予約権（以下「残存新株予約権」という。）の新株予約権者に対し、それぞれの場合につき、会社法第236条第1項第8号のイからホまでに掲げる株式会社（以下「再編対象会社」という。）の新株予約権を以下の条件に基づきそれぞれ交付することとする。この場合においては、残存新株予約権は消滅し、再編対象会社は新株予約権を新たに発行するものとする。ただし、以下の条件に沿って再編対象会社の新株予約権を交付する旨を、吸収合併契約、新設合併契約、吸収分割契約、新設分割計画、株式交換契約又は株式移転計画において定めた場合に限るものとする。
    ①　交付する再編対象会社の新株予約権の数
    組織再編行為の効力発生の時点において残存する募集新株予約権の新株予約権者が保有する新株予約権の数と同一の数をそれぞれ交付するものとする。
    ②　新株予約権の目的である再編対象会社の株式の種類
    再編対象会社の普通株式とする。
    ③　新株予約権の目的である再編対象会社の株式の数
    組織再編行為の条件等を勘案のうえ、前記（１）に準じて決定する。
    ④　新株予約権の行使に際して出資される財産の価額
    交付される各新株予約権の行使に際して出資される財産の価額は、組織再編行為の条件等を勘案のうえ、前記（２）で定められた行使価額を調整して得られる再編後払込金額に上記③に従って決定される当該新株予約権の目的である再編対象会社の株式の数を乗じて得られる金額とする。
    ⑤　新株予約権を行使することができる期間
    前記（３）に定める新株予約権を行使できる期間の開始日と組織再編行為の効力発生日のうちいずれか遅い日から、前記（３）に定める新株予約権を行使することができる期間の満了日までとする。
    ⑥　新株予約権の行使の条件
    前記（６）に準じて決定する。
    ⑦　増加する資本金及び資本準備金に関する事項
    前記（４）に準じて決定する。
    ⑧　譲渡による新株予約権の取得の制限
    譲渡による新株予約権の取得については、再編対象会社の承認を要するものとする。
    ⑨　新株予約権の取得事由
    前記（７）に準じて決定する。
    （９） 新株予約権の行使により発生する端数の切捨て
    新株予約権者に交付する株式の数に1株に満たない端数がある場合には、これを切り捨てるものとする。

    （新株予約権の行使制限等）
    第３条　　乙は、本新株予約権の行使に関し、前条の【新株予約権の要領】５．（６）に定める行使条件のほか、次の各号の制限を受けるものとする。
    （１）第２条【新株予約権の要領】５．（３）の定めにかかわらず、割当新株予約権の行使は第２条【新株予約権の要領】５．（３）で定める権利行使可能期間のうち、付与決議の日後2年を経過した日から付与決議の日後10年を経過する日までの期間内に行わなければならないものとする。なお、本契約において付与決議とは、割当新株予約権にかかる会社法第238条第2項の決議（同法第239条第1項の決議による委任に基づく同項に規定する募集事項の決定及び同法第240条第1項の規定による取締役会の決議を含む。）により新株予約権を与えられた者とされた当該決議を意味するものとする。
    （２）1年間（各年の1月1日から12月31日まで）に行使される割当新株予約権の権利行使価額の合計額は1200万円を超えないものとし、新株予約権者はその範囲内でのみ割当新株予約権を行使できる。なお、1年間に行使される割当新株予約権の権利行使価額の合計額が1200万円を超えない場合であっても、当社から割当新株予約権とは別に付与された、会社法に基づく新株予約権並びに他の会社から付与された新株予約権等の権利行使価額とあわせて1200万円を超える場合には、その1200万円を超えることとなる新株予約権等の行使については租税特別措置法第29条の2の課税の特例の適用を受けることはできないので、新株予約権者はこの点に注意するものとする。
    （３）当社及び新株予約権者は、第２条【新株予約権の要領】５．（２）に定める割当新株予約権の行使に係る1株当たりの権利行使価額が本契約の締結時点における株式１株当たりの価額に相当する金額以上であることをここに確認する。
    （４）新株予約権者は、第２条【新株予約権の要領】５．（５）にかかわらず、割当新株予約権につき、第三者に対する譲渡、担保設定その他の処分をすることはできないものとする。
    （５）割当新株予約権の行使による株式の交付は、当該交付のために付与決議がされた会社法第238条第1項に定める事項に反しないで行われるものとする。
    （６）新株予約権者は、割当新株予約権の行使により取得する株式につき、当該行使に係る会社と金融商品取引業者又は金融機関（以下「金融商品取引業者等」という。）との間であらかじめ締結される新株予約権等の行使により交付される会社の株式の振替口座簿への記載若しくは記録、保管の委託又は管理及び処分に係る信託（以下「管理等信託」という。）に関する取り決めに従い、当該取得後直ちに、当社を通じて、当該金融商品取引業者等の振替口座簿に記載若しくは記録を受け、又は当該金融商品取引業者等の営業所若しくは事務所に保管の委託若しくは管理等信託を行うものとする。なお、かかる金融商品取引業者等については追って当社より権利者に通知する。
    （７）前各項の定めは、本契約の他の条項及び第2条【新株予約権の要領】のいずれの規定にも優先するものとする。

    （新株予約権の行使手続等）
    第４条　　乙は、本新株予約権を行使する場合、甲の指定する払込取扱い場所に所定の金額を払い込むとともに、所定の様式の新株予約権行使請求書を甲に提出する。
    　　２．　乙は、前項の方法による権利行使を行う場合には、甲所定の方法により指定証券に乙本人名義の口座を開設する。
    　　３．　甲は、前各号の内容の確認を行った後、本新株予約権の行使により乙が取得する株式につき、前項によって開設した指定証券の乙本人名義の振替口座簿への記載若しくは記録、又は指定証券に保管の委託がされるための手続を行なう。

    （権利喪失事由）
    第５条　　乙は、次の各号のいずれかに該当した場合、本新株予約権に係る権利行使請求権を喪失する。ただし、取締役会が別に認めた場合はこの限りではない。
    （１）禁錮以上の刑に処せられた場合
    （２）甲の就業規則に定める懲戒処分を受けた場合
    （３）甲の書面による承諾を事前に得ることなく甲の同業他社の役職員に就いた場合
    （４）書面により本新株予約権の全部又は一部を放棄する旨申し出た場合
    （５）在任・在職中に故意又は過失により過去及び将来にわたり甲に損害を与え若しくは信用を毀損したと取締役会が認めた場合
    （６）乙が差押、仮差押、仮処分、強制執行若しくは競売の申立を受け、又は公租公課の滞納処分を受けた場合
    （７）乙が支払停止若しくは支払不能となり、又は振り出し若しくは引き受けた手形若しくは小切手が不渡りとなった場合
    （８）乙につき破産手続開始、民事再生手続開始、会社更生手続開始、特別清算手続開始その他これらに類する手続開始の申立があった場合
    （９）乙が反社会的勢力（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、その他暴力、威力又は詐欺的手法を使用して経済的利益を追求する集団又は個人を意味する。以下同じ。）であること、又は資金提供等を通じて反社会的勢力と何らかの交流若しくは関与を行っていることが判明した場合

    （確約書の締結）
    第６条　　乙は、甲が要請した場合には、割当新株予約権及び割当新株予約権の行使により交付される株式について、甲との間で、金融商品取引所又は日本証券業協会の定める様式による新株等の継続所有等に関する「確約書」を締結するものとし、かかる確約書の締結がない場合には、乙は割当新株予約権を行使することができないものとする。新株予約権に関する金融商品取引所又は日本証券業協会の規則等に変更があった場合には、乙は甲の指示に従い必要な手続を行うものとする。

    （意思表示及び通知の方法）
    第７条  　甲は、乙に対する意思表示及び通知を、次の各号に定める方法により行う。
    （１）乙が在職中の場合　乙に対し、直接、書面を交付する。
    （２）乙が退職した場合　乙の住所又は国内連絡場所に宛てて、書面を発送する。
    ２．　前項第２号の書面は、乙の住所又は国内連絡場所に、通常、到達すべき時期に到達したものとみなす。

    （契約の改定）
    第８条　　本契約の条項が所得税法、法人税法その他の税法の規定、会社法、金融商品取引法その他の関連法令に適合しないことが判明し、又は本契約締結後の改正によりこれらの関連法令に適合しなくなった場合、甲は、乙に通知することにより、本契約の条項の変更を提案することができる。
    　　２．　前項の変更をする場合、甲は、提案の内容、異議申出の期限、変更の効力発生予定日、期限までに書面による異議申出がないときは提案に同意したものとみなされる旨を前項の通知に記載するものとする。ただし、通知の発送日から異議申出の期限までの期間は２週間以上とする。
    　　３．　前項の異議申出の期限までに、乙より書面による異議申出がない場合、乙は第1項に規定する甲の提案に同意したものとし、前項に定める変更の効力発生予定日をもって、本契約は甲の提案したとおり変更されたものとする。

    （関係法令の遵守）
    第９条　　乙は、本新株予約権の行使及び行使により取得した株式の売却に関して、会社法、金融商品取引法その他一切の関係法令及び当社の内部規程を遵守しなければならないものとする。

    （費用の負担）
    第10条　　乙による本新株予約権の行使に係る株式の取得及び当該取得した株式の売却その他の処分に関連して発生する租税その他の費用は、すべて乙の負担とする。

    （規定外事項の取扱い）
    第11条   本契約に規定されていない事項の処理に関しては、甲乙誠意をもって協議を行い、決定するものとする。


    上記合意の証として、本契約書を２通作成し、甲乙記名押印の上、各自1通ずつ保有する。

    ●年●月●日

    　　　　　　　　　　　甲　　　　（会社名称）
    　　　　　　　　　　　　　　　　（会社住所）
    　　　　　　　　　　　　　　　　（代表者役職・氏名）　　　　　　　　（印）


    　　　　　　　　　　　乙　　　　（割当人住所）
    　　　　　　　　　　　　　　　　（割当人氏名）　　　　　　　　　　　（印）`,
  },
];
